import { numberService } from "./numbers.service"
import { NumbersDO } from "./numbers.data"
import { NumberOptionsMap, NumberType } from "./numbers.models"

import './numbers.scss'

export class NumberComponent extends HTMLElement {
    private static _sharedData: NumbersDO | null = null
    private static _loadingPromise: Promise<NumbersDO> | null = null
    private _numberId: string | null

    constructor() {
        super()
    }

    connectedCallback() {
        this._numberId = this.getAttribute('number-id')
        this.init()
    }

    async init() {
        await NumberComponent.loadData()
        if (!NumberComponent._sharedData) { console.error('Number data is not loaded'); return }
        if(!this._numberId) { console.error('Number ID is not set'); return }

        const numberElement = this.createNumberElement(this._numberId)
        if (!numberElement) { console.error('Number element is not created'); return }
        this.appendChild(numberElement)
        this.parentElement && this.parentElement.classList.contains('tbw-number') ? this.parentElement.style.display = 'flex' : this.style.display = 'flex'
    }
    
    static async loadData() {
        if (!NumberComponent._sharedData) {
            if (!NumberComponent._loadingPromise) {
                NumberComponent._loadingPromise = numberService.load()
            }
            NumberComponent._sharedData = await NumberComponent._loadingPromise
        }
        return NumberComponent._sharedData
    }

    private createNumberElement(numberId: string) {
        if (!NumberComponent._sharedData) { console.error('Number data is not loaded'); return }

        const data = NumberComponent._sharedData[numberId]
        const numberFormatter = NumberOptionsMap.get(numberId as NumberType)
        if (!numberFormatter) { console.error('Number format is not set'); return }

        const formattedNumber = numberFormatter.format(data)
        const numberColor = numberFormatter.color ? numberFormatter.color(data) : 'var(--midnight-blue)'

        const numberElement = document.createElement('p')
        numberElement.className = 'headline-5'
        numberElement.textContent = formattedNumber
        numberElement.style.color = numberColor
        return numberElement
    }
}
